import { useMemo, useEffect, useState } from 'react';
import Cookies from 'js-cookie';

/**
 * Custom hook to access trial status from cookies
 * @returns {Object} Trial status object with helper properties
 */
export const useTrialStatus = () => {
  const [cookieValue, setCookieValue] = useState(() => Cookies.get('trialStatus'));

  useEffect(() => {
    const checkCookie = () => {
      const currentCookie = Cookies.get('trialStatus');
      if (currentCookie !== cookieValue) {
        setCookieValue(currentCookie);
      }
    };

    checkCookie();

    const interval = setInterval(checkCookie, 1000);

    return () => clearInterval(interval);
  }, [cookieValue]);

  const trialStatus = useMemo(() => {
    if (!cookieValue) {
      return null;
    }

    try {
      const parsed = JSON.parse(cookieValue);
      return parsed;
    } catch (e) {
      console.error('[useTrialStatus] Failed to parse trial status:', e);
      return null;
    }
  }, [cookieValue]);

  return {
    trialStatus,
    isOnTrial: trialStatus?.is_on_trial ?? false,
    isPaid: trialStatus?.is_paid ?? false,
    daysRemaining: trialStatus?.days_remaining ?? null,
    showWarning: trialStatus?.show_warning ?? false,
    trialExpiresAt: trialStatus?.trial_expires_at ?? null,
    subscriptionEndDate: trialStatus?.subscription_end_date ?? null,
    maxConnectors: trialStatus?.max_connectors ?? 5,
    connectorsLimitEnabled: trialStatus?.connectors_limit_enabled ?? true,
    source: trialStatus?.source ?? null,
    trialStartDate: trialStatus?.trial_start_date ?? null,
  };
};
